import { RadioGroup } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { RebuildRouteDropdownRadioOption } from "@ryde/controls";
import {
  DirectionsServiceEnum,
  formatRebuildRouteProviderOptimizationLabel,
  RebuildRouteTypeEnum,
  resolveDirectionsServiceLabel,
} from "@ryde/shared";

interface IBulkRebuildRoutesCustomOptionsSelectorProps {
  routeOption: RebuildRouteTypeEnum;
  selectedProvider: DirectionsServiceEnum;
  onRouteOptionChange: (option: RebuildRouteTypeEnum) => void;
}

export const BulkRebuildRoutesCustomOptionsSelector: FC<
  IBulkRebuildRoutesCustomOptionsSelectorProps
> = ({ routeOption, selectedProvider, onRouteOptionChange }) => {
  const { t } = useTranslation();
  const providerLabel =
    resolveDirectionsServiceLabel(selectedProvider) ?? selectedProvider;
  const providerOptimizationLabel = formatRebuildRouteProviderOptimizationLabel(
    {
      provider: selectedProvider,
      t,
    },
  );

  return (
    <div className="rebuild-route-dropdown-options">
      <RadioGroup
        value={routeOption}
        onChange={e =>
          onRouteOptionChange(e.target.value as RebuildRouteTypeEnum)
        }
      >
        <RebuildRouteDropdownRadioOption
          value={RebuildRouteTypeEnum.OptimizeStationOrderOsrmFirst}
          label={t("general.OPTIMIZE_STATIONS_ORDER_DEFAULT")}
          tooltip={t("general.OPTIMIZE_STATIONS_ORDER_TOOLTIP")}
        />
        <RebuildRouteDropdownRadioOption
          value={RebuildRouteTypeEnum.BestFit}
          label={t("general.REBUILD_BEST_FIT")}
          tooltip={t("general.REBUILD_BEST_FIT_TOOLTIP")}
        />
        <RebuildRouteDropdownRadioOption
          value={RebuildRouteTypeEnum.ProviderOptimization}
          label={providerOptimizationLabel}
          tooltip={t("general.PROVIDER_OPTIMIZATION_TOOLTIP", {
            provider: providerLabel,
          })}
        />
        <RebuildRouteDropdownRadioOption
          value={RebuildRouteTypeEnum.KeepOrder}
          label={t("general.REBUILD_KEEP_ORDER")}
          tooltip={t("general.REBUILD_KEEP_ORDER_TOOLTIP")}
        />
        <RebuildRouteDropdownRadioOption
          value={RebuildRouteTypeEnum.EndpointsLocked}
          label={t("general.REBUILD_ENDPOINTS_LOCKED")}
          tooltip={t("general.REBUILD_ENDPOINTS_LOCKED_TOOLTIP")}
        />
      </RadioGroup>
    </div>
  );
};
